<label>
  <input type="radio"
       [name]="(name) ? name : ''"
       [value]="(value) ? value : radioImage.id"
       [(ngModel)]="selectedImageId"
       (ngModelChange)="change($event)">
  <img [src]="radioImage.src"
     [style.width.px]="width"
     [style.height.px]="height">
</label>
